import { render, staticRenderFns } from "./order-recharge-list.vue?vue&type=template&id=3b31de2a&scoped=true"
import script from "./order-recharge-list.vue?vue&type=script&lang=js"
export * from "./order-recharge-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31de2a",
  null
  
)

export default component.exports